import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const backgroundImage = isMobile
    ? "https://geneartai.com/images/mobile1.png"
    : "https://geneartai.com/images/image1.png";

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden">

      {/* Responsive Background */}
      <div
        className="fixed inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundAttachment: isMobile ? "scroll" : "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0"></div>
      </div>

      {/* Foreground Content */}
      <div className="relative z-10 flex flex-col min-h-screen">

        {/* Top Spacer for Navbar */}
        <div className="pt-28" />

        {/* Main Content */}
        <div className="flex-grow flex flex-col items-center justify-center text-center p-6">
          <div className="bg-black/20 backdrop-blur-md p-10 rounded-2xl shadow-2xl max-w-lg w-full">
            <h1 className="text-6xl font-extrabold mb-6">404</h1>
            <p className="text-2xl mb-6">Oops! Page not found.</p>
            <Link
              to="/"
              className="bg-white text-[#166CB0] font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition duration-300 shadow-md hover:shadow-lg"
            >
              Go Home
            </Link>
          </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-xs text-gray-300 pb-3">
          <div>© 2025 GeneArtAI — All Rights Reserved.</div>
          <div className="mt-2">
            <Link to="/privacy-policy" className="text-gray-300 hover:text-white underline">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms-of-service" className="underline hover:text-white">
              Terms of Service
            </Link>
          </div>
        </footer>

        {/* Mobile Bottom Spacer */}
        <div className="block sm:hidden h-20" />
      </div>
    </div>
  );
}
